<template>
    <div v-if="f.type === 'number'" class="mb-3">
        <label :for="f.slug" class="form-label">{{ f.description }}</label>
        <input type="number" :id="f.slug" class="form-control" :name="f.slug" min="1"
            v-model="f.function_limit" required>
    </div>
    <div v-if="f.type === 'switch'" class="mb-3">
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" :name="f.slug"
                :id="f.slug" :checked="f.function_limit === 'on' ? true : false">
            <label class="form-check-label" :for="f.slug">{{ f.description }}</label>
        </div>
    </div>
    <div v-if="f.slug === 'widgets'" class="mb-3">
        <label :for="f.slug" class="form-label">{{ f.description }}</label>
        <div class="d-flex gap-2 align-items-center">
            <div class="form-check form-switch m-0">
                <input class="form-check-input" type="checkbox" role="switch"
                    :name="f.slug" :id="f.slug" checked>
            </div>
            <input type="number" class="form-control" :id="f.slug" :placeholder="$t('plans.function.quantity')"
                :name="f.slug + 'Number'" :value="f.function_limit">
        </div>
    </div>
    <div v-if="f.slug === 'call_center'" class="mb-3">
        <label class="form-label">{{ $t('plans.function.callCenter') }}</label>
        <div class="d-flex gap-2 align-items-center">
            <div class="form-check form-switch m-0">
                <input class="form-check-input" type="checkbox" role="switch"
                    name="mvoterCallCenterSwitch" id="callCenterSwitch"
                    :checked="f.function_limit !== 'null' ? true : false">
            </div>
            <input type="number" class="form-control" name="mvoterCallCenterPrice"
                id="mvoterCallCenterPrice" :placeholder="$t('plans.function.pricePerMonth')"
                :value="f.function_limit">
        </div>
    </div>
    <div v-if="f.type === 'check-group' && f.slug === 'languages'" class="mb-3">
        <label class="form-label">{{ f.description }}</label>
        <div class="d-flex gap-2 flex-wrap">
            <input type="checkbox" class="btn-check" id="checkKZ" name="superqrLangKZ"
                :checked="f.function_limit.split(',').includes('KZ') ? true : false"
                autocomplete="off">
            <label class="lang-chip" for="checkKZ">KZ</label>

            <input type="checkbox" class="btn-check" id="checkRU" name="superqrLangRU"
                :checked="f.function_limit.split(',').includes('RU') ? true : false"
                autocomplete="off">
            <label class="lang-chip" for="checkRU">RU</label>

            <input type="checkbox" class="btn-check" id="checkEN" name="superqrLangEN"
                :checked="f.function_limit.split(',').includes('EN') ? true : false"
                autocomplete="off">
            <label class="lang-chip" for="checkEN">EN</label>
        </div>
    </div>
</template>

<script>
export default {
    data:() => ({
        val: ''
    }),
    props: {
        f: {
            type: Object,
            default: {}
        }
    }
}
</script>

<style scoped>
.lang-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 14px;
    background: #fff;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    cursor: pointer;
    transition: all 0.12s ease;
    user-select: none;
}
.lang-chip:hover {
    border-color: #c4b5fd;
    background: #faf7ff;
}
.btn-check:checked + .lang-chip {
    border-color: #7c3aed;
    background: #f5f0ff;
    color: #6d28d9;
}
</style>
